import React, { FC } from 'react'
import Image from 'next/image'
import { imageLoader } from 'src/utils/loader'

const CustomImage: FC<ImageGlobal.NextImage> = ({
  src,
  alt,
  className,
  layout,
  width,
  height,
  placeholder,
  lazy,
  decoding,
}) => {
  // Priority per immagini above-the-fold (non lazy)
  const isPriority = !lazy;
  
  if (layout !== 'fill' && width && height) {
    return (
      // @ts-ignore
      <Image
        loader={imageLoader}
        alt={alt}
        src={src}
        className={className}
        layout={layout}
        width={width}
        height={height}
        placeholder={placeholder}
        priority={isPriority}
        loading={lazy ? 'lazy' : 'eager'}
        decoding={decoding || 'async'}
      />
    )
  }

  return (
    // @ts-ignore
    <Image
      loader={imageLoader}
      alt={alt}
      src={src}
      className={className}
      layout="fill"
      placeholder={placeholder}
      objectFit="contain"
      priority={isPriority}
      loading={lazy ? 'lazy' : 'eager'}
      decoding={decoding || 'async'}
    />
  )
}

export default CustomImage
